import {AlertController, NavController, NavParams, LoadingController, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {AgencyUserBetListPage} from "../agencyUserBetList/agencyUserBetList";

@Component({
    templateUrl: 'agencyUserBetSearch.html',
    selector: 'agency-user-bet-search-page',
})
export class AgencyUserBetSearchPage {
    status: number = -1;
    betid: string = "";
    starttime: string;
    endtime: string;
    lotteryid: number = -1;
    statuslist: any = [];
    lotterylist: any = [];

    constructor(private keyboard: Keyboard, private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController, public loadingCtrl: LoadingController, private userService: UserService) {
        this.initService(navParams.get("data")["loginname"]);
    }

    initService(id: string) {
        let requestData: any = {
            id: id
        };

        this.userService.agentUserBetInit(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.statuslist = data["statuslist"];
                this.lotterylist = data["lotterylist"];
                this.starttime = data["starttime"].replace(" ", "T");
                this.endtime = data["endtime"].replace(" ", "T");
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    searchFn() {
        let requestData: any = {
            status: this.status,
            betid: this.betid,
            starttime: this.starttime.replace("T", ' ').substr(0, 19),
            endtime: this.endtime.replace("T", ' ').substr(0, 19),
            lotteryid: this.lotteryid
        };
        this.userService.agentUserBetSearch(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.nav.push(AgencyUserBetListPage, {
                    requestData: requestData,
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserBetSearch/agencyUserBetSearch.ts